import { renderMarkdown } from "@utils/renderMarkdown";

export async function copyMarkdown(markdown: string): Promise<void> {
  if (typeof ClipboardItem === "undefined" || !navigator.clipboard.write) {
    await navigator.clipboard.writeText(markdown);
    return;
  }
  await navigator.clipboard.write([
    new ClipboardItem({
      "text/html": new Blob([renderMarkdown(markdown)], { type: "text/html" }),
      "text/plain": new Blob([markdown], { type: "text/plain" }),
    }),
  ]);
}
